import React from 'react';
import styles from './PostScheduleCall.module.scss';
import Icon from 'components/Icon/Icon';

const PostScheduleCall = ({ ...rest }) => {
  const leanne = require('static/images/leanne.png').default;

  return (
    <div className={styles.container} {...rest}>
      <div className={styles.clear}>
        <div>
          <img
            alt="Leanne's face in circle"
            title="Leanne from Customer Success Team"
            src={leanne}
          />
        </div>
        <p className="fs-15">
          <strong>Leanne</strong> and the team are here to help.
        </p>
      </div>
      <div className={styles.ctas}>
        <a
          href="/contact"
          target="_blank"
          className={`${styles.email} contact-support`}
        >
          <Icon icon="&#xe686;" color="#ccc" />
          &nbsp;Message via webchat
        </a>
      </div>
    </div>
  );
};

export default PostScheduleCall;
